export * from './chat.js';
export * from './service-response.js';
export * from './storage.js';
export * from './global.js';
export * from './i18n.js';
export * from './type-helper.js';
export * from './event-signal.js';
export * from './user.js';
export * from './photo.js';

Alwatr.registeredList.push({
  name: '@alwatr/type',
  version: _ALWATR_VERSION_,
});
